<template>
  <div>
    <div class="tla-form-group tla-form-group--margin-medium">
      <label class="tla-form-group__label tla-form-group__label--required" v-html="partExchangeLabel"></label>
      <div v-if="questionLabel">
        <label  class="tla-form-group__label" for="PostcodeSearch"
          v-html="questionLabel"></label>
      </div>
      <div class="tla-form-group__touch-points">
        <touchpoint v-for="(item) in options"
          :key="item.touchpointValue"
          :collectionName="'partExchnage'"
          :inputId="item.touchpointValue"
          :inputValue="item.touchpointValue"
          :isSelected="item.preSelect"
          :isRadioStyle="true"
          :validationScope="validationScope"
          @partExchnage="submitPartExchangeVehicle($event)">
          <div class="generic-touchpoint__text" slot="touchpoint" v-html="item.touchpointName"></div>
        </touchpoint>
      </div>
      <span class="tla-form-group__message" :class="getValidationClass('partExchnage', 'message')">
        Please select an option.
      </span>
      <div v-if="showPartExchange && valuationConfirmationText.length > 0" class="part-exchange">
        <img class="part-exchange__image" src="@/assets/images/part-exchange-icon.png"/>
        <p class="part-exchange__text" v-html="valuationConfirmationText"></p>
      </div>
    </div>

    <div class="tla-form-group" v-if="showPartExchange">
      <regLookup :disableRegistrationInput="disableRegistrationInput" :goToNextStep="goToNextStep" :validationScope="validationScope"/>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import GenericTouchpointComponent from '../ui/GenericTouchPointComponent.vue';
import Touchpoint from '../../models/Touchpoint';
import RegistrationLookupComponent from './lookup/RegistrationLookupComponent.vue';
import ExtraData from '../../models/ExtraData';

@Component({
  components: {
  touchpoint: GenericTouchpointComponent,
  regLookup: RegistrationLookupComponent
  }
  })
export default class PartExchangeVehicleComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'Do you have a part-exchange vehicle? <span>*</span>' })
  public partExchangeLabel!: string;

  @Prop({ default: '' })
  public valuationConfirmationText!: string;

  @Prop({ default: true })
  public disableRegistrationInput!: boolean;

  @Prop({ default: true })
  public goToNextStep!: boolean;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: '' })
  public questionLabel!: string;

  public options: Touchpoint[] = [
    new Touchpoint('true', 'Yes'),
    new Touchpoint('false', 'No')
  ];

  private showPartExchange: boolean = false;

  public get manualVehicleModuleKey(): string {
    return this.$store.getters['vehicleValuationModule/moduleKey'];
  }

  public submitPartExchangeVehicle(value: string) {
    const extraData: ExtraData = new ExtraData('hasPartExchangeVehicle', value);
    this.$store.dispatch('enquiryModule/submitExtraData', extraData);
    if (value === 'true') {
      this.showPartExchange = true;
    } else {
      if (this.manualVehicleModuleKey.length > 0) {
        this.$store.dispatch('vehicleManagementModule/submitRemoveModuleInstances', this.manualVehicleModuleKey);
      }

      this.$store.dispatch('vehicleValuationModule/submitResetValuationData');
      this.$store.dispatch('enquiryModule/submitOverlayStep', 1);
      this.showPartExchange = false;
    }
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }
}
</script>
